exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#account h2 {\n  margin: 50px 20px;\n  text-transform: uppercase;\n  font-weight: 500; }\n\n#account .nav-account {\n  margin-bottom: 20px;\n  padding-right: 0; }\n  #account .nav-account a {\n    color: #777777;\n    border-bottom: 1px solid #f1f1f1; }\n    #account .nav-account a:last-child {\n      border-bottom: 0; }\n\n#account .containe {\n  border-left: 1px solid #f1f1f1;\n  margin-bottom: 50px; }\n\n#account .title {\n  display: block;\n  margin-top: 30px;\n  margin-bottom: 10px;\n  font-weight: bold;\n  text-transform: uppercase; }\n\n#account .list-faq {\n  margin-top: 50px; }\n\n#account .search {\n  margin-bottom: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Mustafa/Developpement/noxoe/src/components/admin/admin.component.scss
// module id = ../../../../../src/components/admin/admin.component.scss
// module chunks = main